<template>
  <div class="sp-template">
    <div class="h-title">生成账单</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryCustomerForm" class="demo-form-inline" size="small">
          <el-form-item label="结算周期">
            <el-select v-model.lazy="queryCustomerForm.settlementCycle" filterable clearable placeholder="请选择结算周期" @change="onSubmit">
              <el-option v-for="(d, i) in settlementCycles" :key="i" :label="d.name" :value="d.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="系统">
            <el-select v-model="queryCustomerForm.system" filterable placeholder="请选择系统" @change="onSubmit">
              <el-option v-for="item in systems" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户">
            <el-select v-model.lazy="queryCustomerForm.orgOwner" clearable filterable placeholder="请选择客户" @change="onSubmit">
              <el-option v-for="(d, i) in customerList" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button v-if="in_configs(60201)" type="primary" @click="onSubmit">搜 索</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-button v-if="in_configs(60202)" size="small" @click="generatingBill" class="el-button btn-cyan">生成账单</el-button>
        </div>
      </div>
      <el-table :data="customers" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="客户"></el-table-column>
        <el-table-column prop="username" label="账号"></el-table-column>
        <el-table-column prop="user" label="联系人"></el-table-column>
        <el-table-column prop="customerAttach.salesmanName" label="业务员"></el-table-column>
        <el-table-column prop="customerAttach.customerServiceStaffName" label="客服"></el-table-column>
        <el-table-column prop="customerAttach.customerTypeName" label="客户类型"></el-table-column>
        <el-table-column prop="customerAttach.paymentTermsName" label="结算周期"></el-table-column>
        <el-table-column prop="customerAttach.credits" label="信用额度"></el-table-column>

      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { test: "text" },
      customerList: [],
      customers: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      queryCustomerForm: {
        orgOwner: "",
        system: "TMS",
        settlementCycle: ""
      },
      customerIds: [],
      selectCustomer: [],
      systems: [
        {
          value: "TMS",
          label: "TMS物流系统"
        },
        {
          value: "WMS",
          label: "WMS仓库系统"
        },
        {
          value: "PP",
          label: "小包物流系统"
        }
      ],
      customerTypeMap: {},
      customerTypeList: [
        // { name: "普通客户", value: "NORMAL" },
        // { name: "线上自营", value: "ONLINE_SELF_EMPLOYED" },
        // { name: "线下自营", value: "OFFLINE_SELF_EMPLOYED" },
        // { name: "线上代理", value: "ONLINE_AGENCY" },
        // { name: "线下代理", value: "OFFLINE_AGENCY" }
      ],
      customerServiceStaffs: [],
      settlementCycles: []
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.getCustomerType()
      this.getSettlement();
      this.findByCustomerName();
      this.loadCustomerList();
    }, 500)
  },
  computed: {},
  methods: {
    // 获取客户类型
    getCustomerType() {
      this.$request1.get(
        '/customer/queryCustomerType'
      ).then(res => {
        if(res.data && res.data.length > 0) {
          this.customerTypeList = res.data
          this.customerTypeList.forEach(item => {
            this.customerTypeMap[item.value] = item.name
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getSettlement() {
      let _this = this;
      _this.$request1({
          method: 'GET',
          url: '/customer/settlement',
          withCredentials: true
        })
        .then(res => {
          _this.settlementCycles = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //多选按钮
    handleSelectionChange(val) {
      this.selectCustomer = val;
    },
    //搜索
    onSubmit() {
      this.currentPage = 1;
      this.loadCustomerList();
    },
    generatingBill() {

      if(!this.selectCustomer || this.selectCustomer.length == 0) {
        this.$message({
          message: "请至少选择一个客户！",
          type: "warning"
        });
        return;
      }


      this.customerIds = [];
      if (this.selectCustomer.length > 0) {
        this.selectCustomer.forEach((cus, index) => {
          this.customerIds.push(cus.orgOwner);
        });
      }
      if (this.customers == null || this.customers.length == 0) {
        this.$message({
          message: "当前无客户！",
          type: "info"
        });
        return;
      }
      let msg = "";
      if (this.customerIds.length > 0) {
        msg = "确定生成所选客户的账单？";
      } else {
        msg = "确定生成所有查询结果的账单？";
      }
      this.$confirm(msg, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1
            .post(
              '/customer/generatingBill',
              {
                queryCustomerIds: this.queryCustomerForm.orgOwner,
                selectCustomerIds: this.customerIds,
                settlementCycle: this.queryCustomerForm.settlementCycle,
                systemId: this.queryCustomerForm.system
              }
            )
            .then(res => {
              if (res.data.success) {
                this.$message({
                  message: "生成账单成功",
                  type: "success"
                });
              } else {
                this.$message.error("生成账单失败");
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.loadCustomerList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadCustomerList();
    },
    loadCustomerList() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/customer/querycustomer',
        withCredentials: true,
        params: {
          orgOwner: _this.queryCustomerForm.orgOwner,
          customerType: _this.queryCustomerForm.customerType,
          salesman: _this.queryCustomerForm.salesman,
          customerServiceStaff: _this.queryCustomerForm.customerServiceStaff,
          userStatus: _this.queryCustomerForm.userStatus,
          currentPage: _this.currentPage,
          settlementCycle: _this.queryCustomerForm.settlementCycle,
          pageSize: _this.pageSize,
          systemId: _this.queryCustomerForm.system
        }
      })
        .then(function(res) {
          if (res.data.success) {
            _this.customers = res.data.data;
            _this.total = res.data.total;
          } else {
            _this.customers = [];
            _this.total = 0;
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    findByCustomerName() {
      let _this = this;
      _this.$request1
        .get(
          '/customer/querycustomerAll',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.customerList = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/bill/customerlist.vue